// --- COMPONENTS, PARTS --- //
var $window = $(window);
var $windowWidth = $(window).width();
var $document = $(document);
var $header = $(".header");
var body = $("body");
var htmlElement = $("html");
var bodyDetail = $("body.type-detail");
var bodyIndex = $("body.in-index");
var bodyCategory = $("body.type-category");
var bpXsmall = 480;
var bpSmall = 768;
var bpMedium = 992;
var classIsActive = "is-active";

$(document).ready(function () {
  baseEvents();
  partsRepositionHeader();
  repositionHP();
  // createSliderFromBanners();
  // repositionHeader();
  repositionFooter();
  // repositionReview();
  repositionInstagram();
  repositionPartners();
  repositionCategory();
  repositionContact();
  repositionDetail();
  repositionBasket();
});

$(window).load(function () {
  // $("body").addClass("after-load");
});
